module.exports = __webpack_public_path__ + "img/DISCOVER_200x120.4497fb33.jpg";